/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Group, Paper, Space } from '@mantine/core';
import PageSection from '../../../../../../../components/core/PageSection/PageSection';
import { EventServiceType, EventType } from '../../../../../../../models/core/events.type';
import { Feature } from '../../../../../../../utils/constants.utils';
import EventServiceItem from './EventServiceItem';
import EventServiceQuotation from './EventServiceQuotation';

type DataViewProps = {
  data: EventServiceType;
  // eslint-disable-next-line react/no-unused-prop-types
  event: EventType;
};

export default function EventServiceView(props: DataViewProps) {
  return (
    <div>
      <Paper shadow="xs" p="md" withBorder>
        <PageSection size="lg" color={Feature.Home.Event.color} label="Serviço" text="Detalhes do serviço." />
        <Space h="xs" />
        <EventServiceItem data={props.data} />
      </Paper>
      <Space h="lg" />

      <Paper shadow="xs" p="md" withBorder>
        <Group justify="space-between">
          <PageSection
            size="lg"
            color={Feature.Home.Event.color}
            label="Fornecedor"
            text="Detalhes do fornecedor."
          />
        </Group>
        <Space h="xs" />
        <EventServiceQuotation data={props.data.cotacao} />
      </Paper>
    </div>
  );
}
